<template lang="pug">
img(
    :src="logoSrc"
    :alt="$config.runtime.domain"
    :loading="isLazy ? 'lazy' : 'eager'"
)
</template>

<script>
export default {
    name: 'Logo',
    props: {
        isDark: {
            type: Boolean,
            default: false,
        },
        isLight: {
            type: Boolean,
            default: false,
        },
        isLazy: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        logoSrc() {
            let logoFileName = this.$config.runtime.theme.logos.default

            if (this.isDark) logoFileName = this.$config.runtime.theme.logos.dark
            else if (this.isLight) logoFileName = this.$config.runtime.theme.logos.light

            return this.$getAssetUrl(logoFileName)
        },
    },
}
</script>
